import { LadleHeatMetricsPage } from "./LadleHeatMetricsPage";
import { LadleHMProvider } from "./context/LadleHeatMetricContext";

const LadleHeatMetrics = () => {
	return (
		<LadleHMProvider>
			<LadleHeatMetricsPage />
		</LadleHMProvider>
	);
};

export default LadleHeatMetrics;
